import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "timetable-dates" }
const _hoisted_2 = { class: "timetable-dates__list" }
const _hoisted_3 = { class: "date-text weekday" }
const _hoisted_4 = { class: "date-text day" }
const _hoisted_5 = { class: "date-text month" }

import SvgIcon from "@/components/icons/SvgIcon.vue";
import { dayOfWeekName, dayOrdial, monthName, YYYYMMDD } from "@/helpers/dateHelpers";
import { useMediaQuery } from "@vueuse/core";
import { addDays, eachDayOfInterval, startOfToday } from "date-fns";
import { VBtn, VRadio } from "v-ferry-components";
import { computed, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimetableDates',
  emits: ["selectedDate"],
  setup(__props, { emit: __emit }) {

const minDate = ref<Date>(startOfToday());
const activeDate = ref<Date>(startOfToday());

const isMediumScreen = useMediaQuery("(min-width: 720px)");
const isLargeScreen = useMediaQuery("(min-width: 1024px)");

const visibleDates = computed(() => {
    if (isLargeScreen.value) {
        return eachDayOfInterval({
            start: addDays(activeDate.value, -2),
            end: addDays(activeDate.value, 4),
        });
    }

    if (isMediumScreen.value) {
        return eachDayOfInterval({
            start: addDays(activeDate.value, -1),
            end: addDays(activeDate.value, 1),
        });
    }

    return [activeDate.value];
});

const setPrevDate = () => {
    activeDate.value = addDays(activeDate.value, -1);
};

const setNextDate = () => {
    activeDate.value = addDays(activeDate.value, 1);
};

const emit = __emit;

watch(activeDate, (value) => {
    emit("selectedDate", value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VBtn), {
      onClick: setPrevDate,
      class: "timetable-dates__prev",
      disabled: activeDate.value <= minDate.value
    }, {
      default: _withCtx(() => [
        _createVNode(SvgIcon, {
          icon: "chevron-left",
          width: "1.25rem",
          height: "1.25rem"
        })
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDates.value, (date, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createVNode(_unref(VRadio), {
            modelValue: activeDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeDate).value = $event)),
            value: date,
            id: `date-${_unref(YYYYMMDD)(date)}`,
            disabled: date < minDate.value,
            name: "timetable-date",
            class: "timetable-dates__date"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(dayOfWeekName)(date, 3)), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(dayOrdial)(date)), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(monthName)(date, 3)), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "value", "id", "disabled"])
        ]))
      }), 128))
    ]),
    _createVNode(_unref(VBtn), {
      onClick: setNextDate,
      class: "timetable-dates__next"
    }, {
      default: _withCtx(() => [
        _createVNode(SvgIcon, {
          icon: "chevron-right",
          width: "1.25rem",
          height: "1.25rem"
        })
      ]),
      _: 1
    })
  ]))
}
}

})